module.exports = require("protobufjs-cli/pbts");